import React, { useEffect, useState } from "react";
import "../Episodes.css";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import JwPlayerMultiLanguage from "../../Players/EpisodesDetailPlayer/JwPlayerMultiLanguage";
import { useAuthStudent } from "../../../../../context/StudentLoginContext/StudentAuthContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import EpisodeCarousel from "../Carousel/EpisodeCarousel";
import BackButton from "../../../GoBack/GoBack";
import { StudentMapMenu } from "../../../Map/MapMenu/MapMenu";
import { Modal, Button } from "react-bootstrap";
import { useGetQuestChapterDetail } from "../../../../../../hooks/student/quest/useGetQuestChapterDetail";
import JWPlayerStudentMultiLanguage from "../../Players/EpisodesDetailPlayer/JWPlayerStudentMultiLanguage";
import { useGetQuestsList } from "../../../../../../hooks/student/quest/useGetQuestsList";
import { useGetQuestChapters } from "../../../../../../hooks/student/quest/useGetQuestChapters";
import { useAuth } from "../../../../../context/LoginContext/AuthContext";

export const StudentAdminEpisodeDetail = () => {
  const { user } = useAuth();
  const { questId, chapterId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiImgurl = process.env.REACT_APP_IMG_URL;
  const { student, fetchWithAuthStudent } = useAuthStudent();
  const [chapters, setChapters] = useState(null);
  const [questChapters, setQuestChapters] = useState(null);
  const [lastFetchedDetails, setLastFetchedDetails] = useState(null);
  const [videoLoading, setVideoLoading] = useState(true);
  const [titleLoading, setTitleLoading] = useState(true);
  const [carouselLoading, setCarouselLoading] = useState(true);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const { userType } = useOutletContext() || {};
  const isSchoolStudent = userType === "school-student";
  const currentUser = user?.user || student?.student;
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;

  const {
    questChapterDetail,
    loading: chapterDetailLoading,
    getStudentQuestChapterDetail,
  } = useGetQuestChapterDetail();
  const {
    questChapters: newquestChapters,
    loading: schoolChaptersLoading,
    getStudentQuestChapters,
  } = useGetQuestChapters();

  useEffect(() => {
    if (isSchoolStudent && chapterId) {
      getStudentQuestChapterDetail(chapterId);
    }
  }, [isSchoolStudent, chapterId]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSchoolStudent) {
      getStudentQuestChapters(); // 🔥 call on mount for school student
    }
  }, [isSchoolStudent, questId]);

  useEffect(() => {
    if (!isSchoolStudent) {
      setChapters(null);
      setVideoLoading(true);
    }
  }, [chapterId, isSchoolStudent]);

  useEffect(() => {
    if (!isSchoolStudent) {
      setLastFetchedDetails(null);
      setQuestChapters(null);
      setTitleLoading(true);
      setCarouselLoading(true);
    }
  }, [questId, isSchoolStudent]);

  useEffect(() => {
    let isMounted = true;
    const fetchChapterData = async () => {
      if (!student || !student.token) return;

      try {
        setVideoLoading(true);
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapter/${chapterId}`,
          {
            method: "GET",
          },
        );
        if (!response.ok) {
          throw new Error("Failed to fetch chapter video");
        }

        const data = await response.json();

        if (
          data?.message === "Subscription required to access this video." &&
          data?.access === "denied"
        ) {
          if (isMounted) {
            setShowSubscriptionModal(true);
            setVideoLoading(false);
          }
          return;
        }

        if (isMounted) {
          setChapters(data);
        }
      } catch (error) {
        // keep null on error
      } finally {
        if (isMounted) {
          setVideoLoading(false);
        }
      }
    };

    if (!isSchoolStudent) {
      fetchChapterData();
    }

    return () => {
      isMounted = false;
    };
  }, [apiUrl, student, chapterId, fetchWithAuthStudent, isSchoolStudent]);

  useEffect(() => {
    let isMounted = true;
    const fetchQuestChapters = async () => {
      if (!student || !student?.token) return;

      try {
        setCarouselLoading(true);
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapters/${questId}`,
          {
            method: "GET",
          },
        );

        if (!response.ok) throw new Error("Failed to fetch chapters");

        const data = await response.json();
        if (isMounted) {
          setQuestChapters(data?.chapters);
        }
      } catch (error) {
        // keep null on error
      } finally {
        if (isMounted) {
          setCarouselLoading(false);
        }
      }
    };

    if (!isSchoolStudent) {
      fetchQuestChapters();
    }

    return () => {
      isMounted = false;
    };
  }, [apiUrl, student, questId, fetchWithAuthStudent, isSchoolStudent]);

  useEffect(() => {
    let isMounted = true;
    const fetchQuestDetails = async () => {
      if (!student || !student?.token) return;

      try {
        setTitleLoading(true);
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest/${questId}`,
          {
            method: "GET",
          },
        );

        if (!response.ok) throw new Error("Failed to fetch details");

        const data = await response.json();
        if (isMounted) {
          setLastFetchedDetails(data);
        }
      } catch (error) {
        // keep null on error
      } finally {
        if (isMounted) {
          setTitleLoading(false);
        }
      }
    };

    if (!isSchoolStudent) {
      fetchQuestDetails();
    }

    return () => {
      isMounted = false;
    };
  }, [apiUrl, student, questId, fetchWithAuthStudent, isSchoolStudent]);

  const isVideoLoading = isSchoolStudent ? chapterDetailLoading : videoLoading;
  const isTitleLoading = isSchoolStudent ? chapterDetailLoading : titleLoading;
  const isCarouselLoading = isSchoolStudent ? schoolChaptersLoading : carouselLoading;
  const loading = isVideoLoading || isTitleLoading || isCarouselLoading;
  const loadingvideo = isVideoLoading;
  // console.log(isPaused);

  const videoSchoolStudentSources = React.useMemo(() => {
    if (!questChapterDetail?.chapter) return null;

    return {
      en:
        questChapterDetail?.chapter?.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${questChapterDetail?.chapter?.jwpIdEnglish}.m3u8`
          : `${apiImgurl}/code/public/storage/${questChapterDetail?.chapter?.videoEng}`,
      hi:
        questChapterDetail?.chapter?.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${questChapterDetail?.chapter?.jwpIdHindi}.m3u8`
          : `${apiImgurl}/code/public/storage/${questChapterDetail?.chapter?.videoHin}`,
    };
  }, [questChapterDetail, apiImgurl]);

  console.log("episode detail Video Sources:", videoSchoolStudentSources);

  const videoSources = React.useMemo(() => {
    if (!chapters?.chapter) return null; // Prevent null error

    return {
      en:
        chapters.chapter.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${chapters.chapter.jwpIdEnglish}.m3u8`
          : `${apiImgurl}/code/public/storage/${chapters.chapter.videoEng}`,
      hi:
        chapters.chapter.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${chapters.chapter.jwpIdHindi}.m3u8`
          : `${apiImgurl}/code/public/storage/${chapters.chapter.videoHin}`,
    };
  }, [chapters, apiImgurl]);
  const navigate = useNavigate();
  return (
    <div className="StudentAdminBody StudentBodyMrgn">
      {showSubscriptionModal && (
        <Modal
          show={showSubscriptionModal}
          backdrop="static"
          centered
          onHide={() => setShowSubscriptionModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Subscription required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Please purchase a subscription to watch this video.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => navigate("/student/admin/quests")} // Wrap in arrow function
            >
              Go to Quests
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {/* //changes */}
      <div className="container-fluid ">
        <div className="teacher-bodycontent mb-4">
          <section>
            <div className="row mb-4">
              <div className="col-md-12">
                <BackButton />
              </div>
            </div>
          </section>
          <div className="row justify-content-center">
            <div
              style={{
                paddingBottom: "20px",
                position: "relative",
                zIndex: 1,
              }}
            >
              {isVideoLoading ? (
                <Skeleton
                  width="100%"
                  borderRadius={20}
                  style={{
                    aspectRatio: "16 / 9",
                    borderRadius: "20px",
                    display: "block",
                  }}
                />
              ) : userType === "school-student" ? (
                <JWPlayerStudentMultiLanguage
                  key={
                    videoSchoolStudentSources?.en ||
                    videoSchoolStudentSources?.hi
                  }
                  questId={questId}
                  videoSources={videoSchoolStudentSources}
                  nextEpisodeId={questChapterDetail?.next_chapter?.id}
                  videoStartTime={
                    Number(
                      questChapterDetail?.remaining_time?.videoTimeStamp,
                    ) || 0
                  }
                  chapters={questChapterDetail}
                  type="quest"
                  isPaused={isPaused}
                  setIsPaused={setIsPaused}
                />
              ) : (
                <JwPlayerMultiLanguage
                  questId={questId}
                  videoSources={videoSources}
                  nextEpisodeId={chapters?.next_chapter}
                  videoStartTime={
                    Number(chapters?.remaining_time?.videoTimeStamp) || 0
                  }
                  chapters={chapters}
                  type="quest"
                  isPaused={isPaused}
                  setIsPaused={setIsPaused}
                />
              )}
            </div>
            <div>
              {userType === "school-student" ? (
                <p className="EpisodeTrailerVideo-Titl mb-2">
                  {isTitleLoading ? (
                    <Skeleton width={200} />
                  ) : (
                    `${questChapterDetail?.chapter?.quest_name || ""} ${questChapterDetail?.chapter?.title || ""}`
                  )}
                </p>
              ) : (
                <p className="EpisodeTrailerVideo-Titl mb-2">
                  {isTitleLoading ? (
                    <Skeleton width={200} />
                  ) : (
                    lastFetchedDetails?.title
                  )}{" "}
                </p>
              )}
            </div>

            <div className="col-md-12 mt-4">
              {userType === "school-student" ? (
                <EpisodeCarousel
                  slides={newquestChapters}
                  loading={isCarouselLoading}
                />
              ) : (
                <EpisodeCarousel
                  slides={questChapters}
                  isSubscribed={isSubscribed}
                  loading={isCarouselLoading}
                />
              )}
            </div>
            {(isMobile || isPaused) && (
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  width: "100%",
                  background: "#fff",
                  zIndex: 10,
                }}
              >
                <StudentMapMenu />
              </div>
            )}
          </div>
          <div style={{}}>
            {/* Left Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                bottom: "auto",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Right Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Page Content */}
          </div>
        </div>
      </div>
    </div>
  );
};
